window.bssB2BHooks = window.bssB2BHooks || { actions: {}, filters: {} };

window.bssB2BHooks.filters["custom:qb/is_show_qb_table_product_list"] = function () {
    return true;
};

if (window.BSS_B2B && window.BSS_B2B.page) {
    window.BSS_B2B.page.isCollectionPage = function() { return true; };
}


window.bssB2BHooks = window.bssB2BHooks || { actions: {}, filters: {} };
window.bssB2BHooks.filters["custom:qb/table_template"] = function (defaultTemplate, context) {
    return function (rule, tableTempData, commonData) {
        const table = new Map();
        table.set("head", []);

        const toNumber = (v) => Number(String(v).replace(/[^\d.]/g, ""));

        const tableData = [...tableTempData.values()];
        for (let i = 0; i < tableData.length; i++) {
            const item = tableData[i];
            const minQty = item.valueFrom;
            const price = item.priceValue;

            let regularPriceStr = item.originPriceValue || '';
            if (!regularPriceStr && rule.price) {
                let currencyMatch = price.match(/[^\d.,\s]+/);
                let symbol = currencyMatch ? currencyMatch[0] : '$';
                let val = Number(rule.price);
                if (val > 1000 && !String(rule.price).includes('.')) {
                    val = val / 100;
                }
                regularPriceStr = symbol + val.toFixed(2);
            }

            // % = ((shopify price - quantity break price) / shopify price) * 100, làm tròn 1 chữ số thập phân
            let discountText = `Save on ${minQty}+`;
            const shopifyPrice = toNumber(regularPriceStr);
            const qbPrice = toNumber(price);
            if (shopifyPrice > 0 && qbPrice >= 0 && qbPrice < shopifyPrice) {
                const percent = ((shopifyPrice - qbPrice) / shopifyPrice * 100).toFixed(1);
                discountText = `Save ${percent}% on ${minQty}+`;
            }

            const cells = [
                `<td class="quantity">
                    <span class="pdp-only">Buy ${minQty}+ cases</span>
                    <span class="collection-only promo-label">${minQty}+ CASES PRICE</span>
                    <span class="collection-only promo-price">${price}</span>
                </td>`,
                `<td class="price pdp-only">
                    ${price}
                </td>`,
                `<td class="discount">
                    <span class="pdp-only">${discountText}</span>
                    <span class="collection-only regular-price">Regularly ${regularPriceStr} / case</span>
                </td>`
            ];

            table.set(String(item.id), cells);
        }

        return table;
    };
};
